import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import Item from "./Item";

const NestedItems = ({
  items,
  collapsed,
  mainLabel,
  level = 0,
  isOpen,
  setIsOpen,
}) => {
  return items.map(
    (
      {
        label: subLabel,
        to: subRoute,
        icon: subIcon,
        items: nestedItems,
        showIcon,
        ...otherProps
      },
      subIndex
    ) => {
      return (
        <>
          {!nestedItems ? (
            <NavLink
              key={subIndex}
              to={subRoute}
              className={`flex items-center select-none cs-ui-sidebar__sublink`}
              style={{ margin: `0px 0px 0px ${level * 16}px` }}
              {...otherProps}
            >
              <Item
                collapsed={collapsed}
                mainLabel={subLabel}
                icon={subIcon}
                isOpen={isOpen}
                showIcon={showIcon}
                className="flex-grow cs-ui-sidebar__link-sub-label"
              />
            </NavLink>
          ) : (
            <div
              className={`flex items-center select-none cs-ui-sidebar__sublink`}
              style={{ margin: `0px 0px 0px ${level * 16}px` }}
              onClick={() => {
                setIsOpen({ ...isOpen, [subLabel]: !isOpen[subLabel] });
              }}
              {...otherProps}
            >
              <Item
                haveNestedItems
                collapsed={collapsed}
                mainLabel={subLabel}
                icon={subIcon}
                isOpen={isOpen}
                showIcon={showIcon}
                className="flex-grow cs-ui-sidebar__link-sub-label"
              />
            </div>
          )}
          {nestedItems && (
            <motion.div
              variants={{
                open: { opacity: 1, height: "max-content" },
                collapsed: { opacity: 0, scale: 0, height: 0 },
              }}
              animate={isOpen[subLabel] ? "open" : "collapsed"}
              transition={{ duration: 0.3 }}
            >
              <NestedItems
                items={nestedItems}
                collapsed={collapsed}
                mainLabel={mainLabel}
                level={level + 1}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
              />
            </motion.div>
          )}
        </>
      );
    }
  );
};
export default NestedItems;
